module.exports = __webpack_public_path__ + "img/1f951.8ac1a03.svg";